import React from "react";
import { HERO } from "@/constants/testIds";
import { ArrowUpRight } from "lucide-react";

const HERO_IMG =
  "https://images.pexels.com/photos/3137050/pexels-photo-3137050.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=1800";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid={HERO.root}
      className="relative overflow-hidden bg-[#f7f5f0] pt-32 pb-20 md:pt-40 md:pb-28"
    >
      {/* Background image, right column */}
      <div className="absolute inset-y-0 right-0 w-full md:w-[45%] pointer-events-none">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${HERO_IMG})` }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#f7f5f0] via-[#f7f5f0]/60 to-transparent md:from-[#f7f5f0]/95 md:via-[#f7f5f0]/30 md:to-transparent" />
        <div className="absolute inset-0 grain" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8 lg:col-span-7 fade-up">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-[#c05c3d]" />
            <span className="overline">Cabinet de courtage · Lyon · Depuis 2025</span>
          </div>

          <h1
            data-testid={HERO.headline}
            className="font-serif text-[44px] sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-[#0a192f]"
          >
            Protéger ce qui compte.
            <br />
            <span className="italic text-[#c05c3d]">Faire prospérer</span> ce qui reste.
          </h1>

          <p className="mt-8 max-w-xl text-lg text-[#475569] leading-relaxed">
            Phenix Patrimoine et Assurance accompagne dirigeants d&apos;entreprise et particuliers
            exigeants dans la construction de couvertures d&apos;assurance et de stratégies
            patrimoniales à la hauteur de leurs ambitions.
          </p>

          <div className="mt-12 flex flex-wrap items-center gap-4">
            <a
              data-testid={HERO.ctaPrimary}
              href="#contact"
              className="group inline-flex items-center gap-3 bg-[#0a192f] text-[#efeade] px-8 py-4 text-sm tracking-wide hover:bg-[#c05c3d] transition-all duration-300"
            >
              Demander un audit gratuit
              <ArrowUpRight
                size={18}
                strokeWidth={1.5}
                className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
              />
            </a>
            <a
              data-testid={HERO.ctaSecondary}
              href="#expertise"
              className="inline-flex items-center gap-2 border border-[#0a192f]/70 text-[#0a192f] px-8 py-4 text-sm tracking-wide hover:bg-[#0a192f] hover:text-[#efeade] transition-all duration-300"
            >
              Découvrir nos expertises
            </a>
          </div>

          {/* Stats bar */}
          <div className="mt-16 grid grid-cols-3 gap-6 max-w-2xl">
            {[
              { k: "2025", v: "cabinet fondé à Lyon" },
              { k: "100%", v: "indépendant" },
              { k: "24 h", v: "délai de réponse" },
            ].map((s, i) => (
              <div key={i} className="border-l border-[#0a192f]/20 pl-4">
                <div className="font-serif text-3xl md:text-4xl text-[#0a192f]">
                  {s.k}
                </div>
                <div className="text-xs uppercase tracking-[0.18em] text-[#475569] mt-1">
                  {s.v}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right editorial card */}
        <div className="hidden md:block md:col-span-4 lg:col-span-5">
          <div className="relative ml-auto max-w-sm bg-[#0a192f] text-[#efeade] p-10 fade-up" style={{ animationDelay: "0.25s" }}>
            <div className="overline text-[#b08d57]">Assurance · Vie · IRD</div>
            <p className="mt-6 font-serif text-2xl leading-snug">
              « Un courtier n&apos;est pas un vendeur — c&apos;est le gardien impartial
              de la sérénité de son client. »
            </p>
            <div className="mt-10 text-xs tracking-[0.24em] uppercase text-[#efeade]/70">
              — Phénix, engagement 2025
            </div>
            <div className="absolute -bottom-2 -right-2 w-full h-full border border-[#c05c3d] -z-10" />
          </div>
        </div>
      </div>
    </section>
  );
}
